import { WindowDimensions } from 'types/state';

export const getWindowDimensions = (): WindowDimensions => {
  return {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  };
};
